export const GET_WO_FOR_MARKETING_EXPENSE = "GET_WO_FOR_MARKETING_EXPENSE";
export const GET_WO_ITEM_FOR_MARKETING_EXPENSE =
  "GET_WO_ITEM_FOR_MARKETING_EXPENSE";
export const GET_ITEM_FOR_MARKETING_EXPENSE = "GET_ITEM_FOR_MARKETING_EXPENSE";
export const GET_MARKETING_EXPENSE = "GET_MARKETING_EXPENSE";
export const GET_MARKETING_EXPENSE_DETAIL = "GET_MARKETING_EXPENSE_DETAIL";
export const GET_MARKETING_EXPENSE_EXPORT = "GET_MARKETING_EXPENSE_EXPORT";
//Marketing Campaign
export const GET_MARKETING_CAMPAIGN = "GET_MARKETING_CAMPAIGN";
export const GET_MARKETING_CAMPAIGN_DETAIL = "GET_MARKETING_CAMPAIGN_DETAIL";
export const GET_MARKETING_CAMPAIGN_FILTER_PROJECT =
  "GET_MARKETING_CAMPAIGN_FILTER_PROJECT";
